import React, { useState } from "react";
import { Button, Col, Dropdown, Radio, Row, Table, notification } from "antd";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import handlePost from "../../utils/Post";
import { BASE_URL } from "../../utils/config";
import eyeIcon from "../../assests/icons/tableeye.png";
import { FaEye } from "react-icons/fa";

const AntDTable = ({ data, loader, link, tabManage, fetchData }) => {
    const [updateStatus, setUpdateStatus] = useState({ id: "", value: "" });
    const [open, setOpen] = useState("");

    const { t } = useTranslation();
    const { Profile, Name, TicketTitle, Details, Status, View } = t(
        "SupportTicket",
        { returnObjects: true }
    );

    const handleUpdateStatus = async (id) => {
        if (id === updateStatus?.id) {
            await handlePost(`${BASE_URL}ticket/update/status/${id}`, {
                status: updateStatus?.value,
            });

            await fetchData(
                tabManage.first
                    ? "ticket/admin/pending/list"
                    : tabManage?.second
                        ? "ticket/admin/open/list"
                        : "ticket/admin/closed/list",
                false
            );

            setUpdateStatus({ id: "", value: "" });
            setOpen("");
            return;
        }

        notification.error({
            message: "Please Select Status",
        });
    };

    const columns = [
        {
            title: Profile,
            dataIndex: "profile",
            key: "profile",
            width: 100,
            render: () => (
                <img
                    className="w-10 h-10 rounded-full"
                    src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS9lzsiRta3FMohvPah30I3q-SZ6POEoMZY74pzBP8n2w&s"
                    alt="profile"
                />
            ),
        },
        {
            title: TicketTitle,
            dataIndex: "title",
            key: "title",
            width: 200,
            render: (title) => <span>{title}</span>,
        },
        {
            title: Details,
            dataIndex: "detail",
            key: "detail",
            width: 280,
            ellipsis: true,
        },
        {
            title: Status,
            dataIndex: "status",
            key: "status",
            width: 160,
            render: (status, item) =>
                status === "pending" ? (
                    <Dropdown
                        open={open === item?.id}
                        placement="bottomRight"
                        trigger={["click"]}
                        dropdownRender={() => (
                            <div className="w-48 bg-white shadow-lg rounded-lg p-3">
                                <Radio.Group
                                    value={
                                        item?.id === updateStatus?.id ? updateStatus?.value : ""
                                    }
                                    onChange={(e) =>
                                        setUpdateStatus({
                                            id: item?.id,
                                            value: e.target.value,
                                        })
                                    }
                                    className="flex flex-col"
                                >
                                    <Radio value="open">OPEN</Radio>
                                    <Radio value="closed">CLOSED</Radio>
                                </Radio.Group>

                                <div className="flex justify-end gap-2 mt-3">
                                    <Button
                                        className="bg-[#161826] border border-[#2A2D3E] hover:border-[#6C5DD3]/50 text-[#8B8FA8] hover:text-white"
                                        onClick={() => setOpen("")}
                                    >
                                        Cancel
                                    </Button>

                                    <Button
                                        className="bg-[#6C5DD3] hover:bg-[#7B6AE0] text-white shadow-[0_0_20px_rgba(108,93,211,0.3)] hover:shadow-[0_0_30px_rgba(108,93,211,0.5)]"
                                        onClick={() => handleUpdateStatus(item?.id)}
                                    >
                                        Update
                                    </Button>
                                </div>
                            </div>
                        )}
                    >
                        <Button onClick={() => setOpen(item?.id)}>{status}</Button>
                    </Dropdown>
                ) : (
                    <Button>{status}</Button>
                ),
        },
        {
            title: "Action",
            key: "action",
            width: 120,
            render: (item) => (
                <Link
                    to={`${link}/ticket/${item?.id}`}
                    className="flex items-center gap-1"
                >
                    <FaEye />
                    <span className="font-medium text-sm leading-none">{View}</span>
                </Link>
            ),
        },
    ];

    return (
        <Table
            rowKey={(item) => item?.id}
            columns={columns}
            dataSource={data}
            loading={loader}
            bordered
            pagination={{
                pageSize: 10,
                showSizeChanger: false,
            }}
            scroll={{
                x: 900,   // horizontal scroll
                y: 400,   // vertical scroll
            }}
            className="w-full"
        />
    );
};

export default AntDTable;